import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  return: null,
  returns: [],
  returnStats: null,
  success: false,
  error: null,
  message: null,
};

export const returnReducer = createReducer(initialState, (builder) => {
  builder
    // Create Sale Return
    .addCase('createSaleReturnRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('createSaleReturnSuccess', (state, action) => {
      state.isLoading = false;
      state.return = action.payload;
      state.success = true;
    })
    .addCase('createSaleReturnFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Get Returns by Store
    .addCase('getReturnsByStoreRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getReturnsByStoreSuccess', (state, action) => {
      state.isLoading = false;
      state.returns = action.payload;
    })
    .addCase('getReturnsByStoreFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Get Return by ID
    .addCase('getReturnByIdRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getReturnByIdSuccess', (state, action) => {
      state.isLoading = false;
      state.return = action.payload;
    })
    .addCase('getReturnByIdFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Update Sale Return
    .addCase('updateSaleReturnRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updateSaleReturnSuccess', (state, action) => {
      state.isLoading = false;
      state.return = action.payload;
      state.success = true;
    })
    .addCase('updateSaleReturnFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Update Purchase Return
    .addCase('updatePurchaseReturnRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updatePurchaseReturnSuccess', (state, action) => {
      state.isLoading = false;
      state.return = action.payload;
      state.success = true;
    })
    .addCase('updatePurchaseReturnFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Update Return Status
    .addCase('updateReturnStatusRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updateReturnStatusSuccess', (state, action) => {
      state.isLoading = false;
      state.return = action.payload;
      state.success = true;
      // Update the return in the returns array
      const index = state.returns.findIndex(ret => ret._id === action.payload._id);
      if (index !== -1) {
        state.returns[index] = action.payload;
      }
    })
    .addCase('updateReturnStatusFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Delete Return
    .addCase('deleteReturnRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteReturnSuccess', (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.success = true;
    })
    .addCase('deleteReturnFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Get Returns by Date Range
    .addCase('getReturnsByDateRangeRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getReturnsByDateRangeSuccess', (state, action) => {
      state.isLoading = false;
      state.returns = action.payload;
    })
    .addCase('getReturnsByDateRangeFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Get Return Statistics
    .addCase('getReturnStatsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getReturnStatsSuccess', (state, action) => {
      state.isLoading = false;
      state.returnStats = action.payload;
    })
    .addCase('getReturnStatsFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Get All Returns (Admin view)
    .addCase('getAllReturnsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllReturnsSuccess', (state, action) => {
      state.isLoading = false;
      state.returns = action.payload;
    })
    .addCase('getAllReturnsFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Clear Errors
    .addCase('clearErrors', (state) => {
      state.error = null;
    })

    // Clear Success Messages
    .addCase('clearSuccess', (state) => {
      state.message = null;
      state.success = false;
    });
});